export class MarketMatrixModel {
setValue(res){
if(res){
}
}
}